import { render, staticRenderFns } from "./SaveProgress.vue?vue&type=template&id=0096b671"
import script from "./SaveProgress.vue?vue&type=script&lang=js"
export * from "./SaveProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports